import React, { Children } from "react";
import { Row, Typography, Col, Card, Breadcrumb, Button } from "antd";
import BreadcrumbItem from "antd/es/breadcrumb/BreadcrumbItem";

const { Text, Link, Title } = Typography;

function ContentTop(props) {
  return (
    <Card
      style={{
        boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
        borderRadius: 20,
        marginBottom: 25,
      }}
    >
      <Col>
        <Row style={{ marginBottom: 0, marginTop: 0 }}>
          <Title level={2} style={{ margin: 0 }}>
            {props.titleOfPage}
          </Title>
        </Row>
        <Breadcrumb style={{ marginBottom: 0 }}>{props.children}</Breadcrumb>

        {/* <Breadcrumb style={{ marginBottom: 0 }}>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Text>Manage Customer</Text>
          </BreadcrumbItem>
        </Breadcrumb> */}
      </Col>
    </Card>
  );
}

export default ContentTop;
